```vue
<template>
  <b-card class="shadow">
    <div class="row">
      <div class="col-12" v-if="!loading">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h5 class="mb-0 text-gray-800">
            {{ $t("Todos os Benefícios") }}
          </h5>

          <b-button-group>
            <b-button
              variant="outline-dark"
              :class="viewFilterReport === true ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>

            <b-button variant="outline-dark" @click="print()">
              <i class="fas fa-print"></i>
            </b-button>

            <b-button
              variant="outline-dark"
              @click="exportar()"
              :title="$t('Exportar')"
              v-b-tooltip.hover
            >
              <i class="fas fa-file-excel"></i>
            </b-button>
          </b-button-group>
        </div>
      </div>

      <div class="col-12" v-if="viewFilterReport">
        <form @submit.prevent="aplicarFiltros" ref="addItem">
          <div class="row">
            <form-select
              v-model="filtroUnidades"
              label="Filtrar por Unidade"
              grid="6"
              :itens="unidades"
              :disabled="desabledSearchUnidade"
              :loading="loadingSearchUnidade"
              :multiple="true"
            />

            <form-select
              v-model="filtroTipos"
              label="Filtrar por Tipo"
              grid="6"
              :itens="tipos"
              :disabled="loadingSearchTipos"
              :loading="loadingSearchTipos"
              :multiple="true"
            />

            <form-select
              v-model="filtroFonteRecursos"
              label="Fonte do Recurso"
              grid="6"
              :itens="$root.arrays.beneficio_fonte"
              :multiple="true"
            />

            <form-select
              v-model="filtroCategorias"
              label="Categoria"
              grid="6"
              :itens="$root.arrays.beneficio_categoria"
              :multiple="true"
            />

            <form-calendar
              v-model="data_inicio"
              grid="3"
              label="Data inicial"
              :max-date="dataNow"
            />

            <form-calendar
              v-model="data_fim"
              grid="3"
              label="Data final"
              :required="verificaDataInicial"
              :min-date="data_inicio"
              :max-date="dataNow"
            />

            <form-select
              v-model="filtroStatus"
              grid="6"
              label="Status"
              :itens="status"
              :loading="loadingStatus"
              :disabled="loadingStatus"
              :multiple="true"
            />

            <form-toggle
              v-model="filtrarConcessoes"
              grid="12"
              label="Filtrar por Número de Concessões?"
            />

            <template v-if="filtrarConcessoes">
              <div class="col-md-12 mb-3">
                <label>
                  <b>Número de Concessões</b>
                </label>

                <vue-slider
                  v-model="filtroConcessoes"
                  :min="min"
                  :max="quatidade_maxima"
                  :tooltip="'always'"
                  :tooltip-placement="'bottom'"
                />
              </div>
            </template>
          </div>

          <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
            <div class="col-auto px-2 text-right">
              <button
                type="button"
                class="btn btn-default"
                @click="viewFilters"
              >
                <i class="fas fa-times"></i>
              </button>

              <button
                type="button"
                class="btn btn-secondary"
                @click.prevent="limparFiltros"
              >
                {{ $t("Limpar Filtros") }}
              </button>

              <button
                class="btn btn-success btn-submit"
                data-style="zoom-in"
                type="submit"
              >
                <i class="fas fa-chart-bar"></i>
                {{ $t("Gerar Relatório") }}
              </button>
            </div>
          </div>
        </form>
      </div>

      <loading-report
        :loading="isLoadingMsg"
        mensagem="Por favor aguarde estamos realizando sua solicitação..."
        icone="fa-smile-wink"
      />

      <load v-if="loading" mode="table" />

      <div v-else class="col-md-12">
        <print-content>
          <template v-slot:datas>
            <p class="d-flex align-items-center justify-content-between mb-4">
              <span>
                Período selecionado:
                <b>{{ datas.start }} - {{ datas.end }}</b>

                <b-link
                  href="#"
                  @click.prevent="void 0"
                  class="mb-2"
                  variant="info"
                  v-b-popover.hover.top="
                    'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                  "
                >
                  <i class="fas fa-info-circle"></i>
                </b-link>
              </span>

              <span v-if="pagination.total">
                Total de Registros
                <b>{{ pagination.total }}</b>,
                total por página
                <b>{{ pagination.perPage }}</b>
              </span>
            </p>
          </template>

          <b-table
            :fields="fields"
            :items="ItemList"
            :responsive="true"
            striped
            hover
            show-empty
            small
            outlined
            stacked="xs"
            table-class="mb-3"
          >
            <template v-slot:cell(nome)="data">
              Tipo:
              <b>{{ data.item.tipo_nome }}</b>

              <br />

              Nome:
              <b>{{ data.item.nome }}</b>

              <br />

              Fonte do Recurso:
              <b>{{ data.item.fonte_recurso_nome }}</b>

              <br />

              Categoria:
              <b>{{ data.item.categoria_nome }}</b>

              <br />

              Protocolo:
              <b>{{ data.item.protocolo }}</b>

              <br />

              <!--
                CORREÇÃO:
                Antes era verificado data.item.unidades.length,
                mas o v-for utiliza unidades_nomes.
              -->
              <span
                v-if="
                  data.item.unidades_nomes &&
                  data.item.unidades_nomes.length > 0
                "
              >
                Unidades

                <ul>
                  <li
                    v-for="(unidade, index) in data.item.unidades_nomes"
                    :key="unidade.id || index"
                  >
                    <b>{{ unidade.nome }}</b>
                  </li>
                </ul>
              </span>
            </template>

            <template v-slot:cell(liberados)="data">
              <span class="small text-muted">
                Concessões:
                <b>{{ data.item.liberados_qtd }}</b>

                <br />

                <span v-if="data.item.quantidade">
                  Qtd. cadastrada:
                  <b>{{ data.item.quantidade }}</b>

                  <br />

                  Qtd. entregue:
                  <b>{{ data.item.quantidade_entregue }}</b>

                  <br />

                  Qtd. disponível:
                  <b>
                    {{
                      Number(data.item.quantidade || 0) -
                      Number(data.item.quantidade_entregue || 0)
                    }}
                  </b>
                </span>
              </span>

              <b-link
                href="#"
                v-if="
                  Number(data.item.concessoes || 0) >
                  Number(data.item.quantidade || 0)
                "
                v-b-tooltip.hover
                title="Atenção! O número de entregas neste benefício é maior que a quantidade disponível"
              >
                <b-icon
                  icon="exclamation-triangle-fill"
                  variant="warning"
                  animation="fade"
                />
              </b-link>
            </template>

            <template v-slot:cell(cadastrado)="data">
              <b v-html="data.item.cadastrado"></b>
            </template>

            <template v-slot:cell(status_nome)="data">
              <span
                class="small"
                v-html="data.item.status_nome"
              ></span>
            </template>

            <template v-slot:empty>
              <div class="text-center my-5">
                <img
                  :alt="$t('No results')"
                  class="mb-5"
                  src="/img/icons/robot.svg"
                  style="max-height: 165px"
                />

                <h3 class="bold">
                  {{ $t("No records found") }}
                </h3>
              </div>
            </template>
          </b-table>
        </print-content>

        <div class="row align-items-center no-print">
          <div class="col-lg-6 col-md-12">
            <div class="form-group d-inline-flex mb-0">
              <select
                class="form-control"
                style="width: 70px"
                v-model.number="perPage"
                @change="alterarQuantidadePorPagina"
              >
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
            </div>

            <div class="d-inline-flex ml-2">
              <b-pagination
                v-model="page"
                :per-page="perPage"
                :total-rows="pagination.total"
                @change="changePage"
              />
            </div>
          </div>

          <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div class="float-lg-right">
              {{ $t("Showing page") }}
              {{ pagination.currentPage }}
              {{ $t("of") }}
              {{ pagination.totalPages }}
              {{ $t("pages in") }}
              {{ pagination.total }}
              {{ $t("records") }}
            </div>
          </div>
        </div>

        <div class="box-btn-print no-print">
          <b-button
            v-if="!loading"
            :title="$t('Visualizar e Imprimir')"
            class="py-2"
            size="sm"
            type="button"
            v-b-tooltip.hover
            variant="primary"
            @click="print()"
          >
            <i class="fas fa-print"></i>
          </b-button>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "HomeReports",

  data() {
    return {
      loading: true,
      isLoadingMsg: false,

      loadingSearchUnidade: true,
      desabledSearchUnidade: true,
      loadingSearchTecnicos: true,
      loadingSearchTipos: true,
      loadingStatus: false,

      range: "yearly",

      ItemList: [],
      unidades: [],
      tecnicos: [],
      tipos: [],
      subtipos: [],
      status: [],

      page: 1,
      perPage: 10,
      search: "",

      pagination: {
        currentPage: 1,
        perPage: 10,
        total: 0,
        totalPages: 0,
      },

      filtros: {},

      data_inicio: "",
      data_fim: "",

      datas: {
        start: "",
        end: "",
      },

      user_id: null,
      tecnico_id: null,
      unidade_id: null,
      role: null,

      quatidade_maxima: 0,

      filtroDatas: [],
      filtroConcessoes: [0, 0],
      filtrarConcessoes: false,
      filtroFonteRecursos: [],
      filtroCategorias: [],
      filtroTipos: [],
      filtroUnidades: [],
      filtroStatus: [],

      verificaDataInicial: false,

      min: 0,
      max: 0,
      enableCross: false,
    };
  },

  computed: {
    fields() {
      return [
        {
          key: "nome",
          label: this.$t("Nome"),
        },
        {
          key: "liberados",
          label: this.$t("Concessões"),
        },
        {
          key: "cadastrado",
          label: this.$t("Cadastrado"),
        },
        {
          key: "status_nome",
          label: this.$t("Status"),
        },
      ];
    },

    listtecnicos() {
      const pessoas = Array.isArray(this.tecnicos)
        ? this.tecnicos
        : [];

      return pessoas.map((elem) => ({
        id: elem.id,
        value:
          " <b>" +
          elem.value +
          "</b> - " +
          elem.nome_unidade,
      }));
    },
  },

  mounted() {
    this.getStatus();
    this.getTipos();
    this.getUnidades();
    this.getAnalytics();
  },

  methods: {
    filterData(value) {
      return this.$options.filters.formatDateHora(value);
    },

    aplicarFiltros() {
      this.page = 1;
      this.getAnalytics();
    },

    alterarQuantidadePorPagina() {
      this.page = 1;
      this.getAnalytics();
    },

    changePage(page) {
      const pagina = Number(page);

      if (
        pagina > 0 &&
        pagina <= this.pagination.totalPages
      ) {
        this.page = pagina;
        this.getAnalytics();
      }
    },

    montarFiltrosDatas() {
      const datas = [];

      if (this.data_inicio) {
        datas.push(
          this.$options.filters.formatDateYMD(
            this.data_inicio
          )
        );
      }

      if (this.data_fim) {
        datas.push(
          this.$options.filters.formatDateYMD(
            this.data_fim
          )
        );
      }

      this.filtroDatas = datas;

      return datas;
    },

    montarParametrosRelatorio() {
      const filtroDatas = this.montarFiltrosDatas();

      return {
        page: this.page,
        search: this.search,
        perPage: this.perPage,

        filtroDatas: filtroDatas,

        filtroConcessoes:
          this.filtrarConcessoes &&
          this.filtroConcessoes &&
          this.filtroConcessoes[1] > 0
            ? this.filtroConcessoes
            : null,

        filtroFonteRecursos:
          this.filtroFonteRecursos,

        filtroCategorias:
          this.filtroCategorias,

        filtroTipos:
          this.filtroTipos,

        filtroUnidades:
          this.filtroUnidades,

        filtroStatus:
          this.filtroStatus,
      };
    },

    normalizarRespostaRelatorio(response) {
      const resposta =
        response && response.data
          ? response.data
          : {};

      const dados = resposta.dados || {};

      /*
       * A API atual parece retornar:
       *
       * resposta.dados.original.data
       * resposta.dados.original.pagination
       *
       * Entretanto, este tratamento também aceita
       * uma paginação padrão do Laravel.
       */
      const original = dados.original || dados;

      let registros = [];
      let paginacao = {};

      if (Array.isArray(original.data)) {
        registros = original.data;
        paginacao = original.pagination || {};
      } else if (
        original.data &&
        Array.isArray(original.data.data)
      ) {
        registros = original.data.data;

        paginacao = {
          currentPage:
            original.data.current_page,

          perPage:
            original.data.per_page,

          total:
            original.data.total,

          totalPages:
            original.data.last_page,
        };
      } else if (Array.isArray(original)) {
        registros = original;
      } else if (
        resposta.data &&
        Array.isArray(resposta.data)
      ) {
        registros = resposta.data;
        paginacao = resposta.pagination || {};
      }

      const currentPage = Number(
        paginacao.currentPage ||
        paginacao.current_page ||
        this.page ||
        1
      );

      const perPage = Number(
        paginacao.perPage ||
        paginacao.per_page ||
        this.perPage ||
        10
      );

      const total = Number(
        paginacao.total !== undefined
          ? paginacao.total
          : registros.length
      );

      const totalPages = Number(
        paginacao.totalPages ||
        paginacao.last_page ||
        (total > 0
          ? Math.ceil(total / perPage)
          : 0)
      );

      return {
        registros: registros,

        pagination: {
          currentPage: currentPage,
          perPage: perPage,
          total: total,
          totalPages: totalPages,
        },

        datas: resposta.datas || {
          start: "",
          end: "",
        },

        quatidade_maxima: Number(
          resposta.quatidade_maxima || 0
        ),
      };
    },

    getAnalytics() {
      this.isLoadingMsg = true;
      this.loading = true;

      const params =
        this.montarParametrosRelatorio();

      return axios
        .get(
          "api/dashboard/report/beneficios/home",
          {
            params: params,
          }
        )
        .then((response) => {
          console.log(
            "Resposta completa do relatório:",
            response.data
          );

          const resultado =
            this.normalizarRespostaRelatorio(
              response
            );

          const usuario =
            this.$store.state.user || {};

          this.user_id =
            usuario.id || null;

          this.tecnico_id =
            usuario.tecnico &&
            usuario.tecnico.id
              ? usuario.tecnico.id
              : null;

          this.unidade_id =
            this.$store.state.unidade || null;

          this.role =
            usuario.role || null;

          this.datas =
            resultado.datas;

          this.ItemList =
            resultado.registros;

          this.pagination =
            resultado.pagination;

          this.quatidade_maxima =
            resultado.quatidade_maxima;

          /*
           * CORREÇÃO:
           * No código anterior estava:
           *
           * [filtroConcessoes[0], ...]
           *
           * Faltava utilizar this.filtroConcessoes.
           */
          this.filtroConcessoes = [
            Number(
              this.filtroConcessoes[0] || 0
            ),
            this.quatidade_maxima,
          ];

          console.log(
            "Registros carregados:",
            this.ItemList
          );

          console.log(
            "Quantidade de registros da página:",
            this.ItemList.length
          );

          console.log(
            "Paginação:",
            this.pagination
          );

          /*
           * Caso a página atual fique maior que
           * o número total de páginas.
           */
          if (
            this.pagination.totalPages > 0 &&
            this.page >
              this.pagination.totalPages
          ) {
            this.page =
              this.pagination.totalPages;

            return this.getAnalytics();
          }

          return response;
        })
        .catch((error) => {
          console.error(
            "Erro ao carregar relatório:",
            error
          );

          if (
            error &&
            error.response
          ) {
            console.error(
              "Resposta do servidor:",
              error.response.data
            );

            console.error(
              "Status HTTP:",
              error.response.status
            );
          }

          this.ItemList = [];

          this.pagination = {
            currentPage: 1,
            perPage: this.perPage,
            total: 0,
            totalPages: 0,
          };
        })
        .finally(() => {
          this.isLoadingMsg = false;
          this.loading = false;
        });
    },

    getUnidades() {
      this.loadingSearchUnidade = true;
      this.desabledSearchUnidade = true;

      axios
        .get(
          "api/dashboard/unidades/get/externas"
        )
        .then((response) => {
          this.unidades =
            Array.isArray(response.data)
              ? response.data
              : [];
        })
        .catch((error) => {
          console.error(
            "Erro ao carregar unidades:",
            error
          );

          this.unidades = [];
        })
        .finally(() => {
          this.loadingSearchUnidade = false;
          this.desabledSearchUnidade = false;
        });
    },

    getTipos() {
      this.loadingSearchTipos = true;

      axios
        .get(
          "api/dashboard/report/get/beneficios/tipos"
        )
        .then((response) => {
          this.tipos =
            Array.isArray(response.data)
              ? response.data
              : [];
        })
        .catch((error) => {
          console.error(
            "Erro ao carregar tipos:",
            error
          );

          this.tipos = [];
        })
        .finally(() => {
          this.loadingSearchTipos = false;
        });
    },

    getSubTipos() {
      this.loadSubtipo = true;
      this.subtipos = [];

      axios
        .get(
          `api/dashboard/report/get/beneficios/subtipos/${this.tipo}`
        )
        .then((response) => {
          this.subtipos =
            Array.isArray(response.data)
              ? response.data
              : [];
        })
        .catch((error) => {
          console.error(
            "Erro ao carregar subtipos:",
            error
          );

          this.subtipos = [];
        })
        .finally(() => {
          this.loadSubtipo = false;
        });
    },

    getStatus() {
      this.loadingStatus = true;

      axios
        .get(
          "api/dashboard/report/get/beneficios/status"
        )
        .then((response) => {
          this.status =
            Array.isArray(response.data)
              ? response.data
              : [];
        })
        .catch((error) => {
          console.error(
            "Erro ao carregar status:",
            error
          );

          this.status = [];
        })
        .finally(() => {
          this.loadingStatus = false;
        });
    },

    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;

      swal.fire({
        title:
          "Aguarde! O Arquivo está sendo gerado.",

        text:
          "O tempo para finalizar pode demorar dependendo da quantidade de registros.",

        imageUrl:
          `${window.urlbase}img/load.gif`,

        showConfirmButton: false,
      });

      const params =
        this.montarParametrosRelatorio();

      params.export = "ok";

      axios
        .get(
          "api/dashboard/report/beneficios/home",
          {
            params: params,
          }
        )
        .then((response) => {
          if (
            !response.data ||
            !response.data.link
          ) {
            throw new Error(
              "A API não retornou o link do arquivo."
            );
          }

          swal.fire({
            title:
              "Arquivo Pronto para Download!",

            html:
              `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,

            icon: "success",

            showConfirmButton: false,
          });
        })
        .catch((error) => {
          console.error(
            "Erro ao exportar relatório:",
            error
          );

          swal.fire({
            title:
              "Não foi possível gerar o arquivo.",

            text:
              "Verifique o console ou os logs do servidor.",

            icon: "error",
          });
        })
        .finally(() => {
          this.isLoadingMsg = false;
          this.loading = false;
        });
    },

    limparFiltros() {
      this.data_inicio = "";
      this.data_fim = "";
      this.verificaDataInicial = false;

      this.filtroDatas = [];

      this.filtroConcessoes = [
        0,
        this.quatidade_maxima,
      ];

      this.filtrarConcessoes = false;
      this.filtroFonteRecursos = [];
      this.filtroCategorias = [];
      this.filtroTipos = [];
      this.filtroUnidades = [];
      this.filtroStatus = [];

      this.page = 1;

      this.getAnalytics();
    },
  },
};
</script>
```
